import React, { useState } from 'react';

interface AssortiColumn {
  name: string;
  order: number;
}

interface AssortiValue {
  columnName: string;
  value: number;
}

interface AssortiTableProps {
  columns: AssortiColumn[];
  values: AssortiValue[];
  onColumnsChange: (columns: AssortiColumn[]) => void;
  onValuesChange: (values: AssortiValue[]) => void;
  readOnly?: boolean;
}

const AssortiTable: React.FC<AssortiTableProps> = ({
  columns,
  values,
  onColumnsChange,
  onValuesChange,
  readOnly = false,
}) => {
  const [newColumnName, setNewColumnName] = useState('');

  const handleAddColumn = () => {
    if (newColumnName.trim()) {
      const newColumn: AssortiColumn = {
        name: newColumnName.trim(),
        order: columns.length,
      };
      onColumnsChange([...columns, newColumn]);
      setNewColumnName('');
    }
  };

  const handleRemoveColumn = (columnName: string) => {
    onColumnsChange(columns.filter(col => col.name !== columnName));
    onValuesChange(values.filter(val => val.columnName !== columnName));
  };

  const handleValueChange = (columnName: string, value: string) => {
    const numValue = parseInt(value) || 0;
    const existingValueIndex = values.findIndex(v => v.columnName === columnName);

    if (existingValueIndex !== -1) {
      const newValues = [...values];
      newValues[existingValueIndex] = { columnName, value: numValue };
      onValuesChange(newValues);
    } else {
      onValuesChange([...values, { columnName, value: numValue }]);
    }
  };

  return (
    <div className="space-y-4">
      {!readOnly && (
        <div className="flex items-center space-x-2">
          <input
            type="text"
            value={newColumnName}
            onChange={(e) => setNewColumnName(e.target.value)}
            placeholder="Yeni sütun adı"
            className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            type="button"
            onClick={handleAddColumn}
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors"
          >
            Sütun Ekle
          </button>
        </div>
      )}

      {columns.length > 0 && (
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-300">
            <thead>
              <tr className="bg-gray-100">
                {columns.map((column) => (
                  <th key={column.name} className="px-4 py-2 border-b">
                    <div className="flex items-center justify-between">
                      <span>{column.name}</span>
                      {!readOnly && (
                        <button
                          type="button"
                          onClick={() => handleRemoveColumn(column.name)}
                          className="text-red-500 hover:text-red-700 ml-2"
                        >
                          ×
                        </button>
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                {columns.map((column) => {
                  const value = values.find(v => v.columnName === column.name)?.value || '';
                  return (
                    <td key={column.name} className="px-4 py-2 border">
                      <input
                        type="number"
                        value={value}
                        onChange={(e) => handleValueChange(column.name, e.target.value)}
                        className="w-full border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        min="0"
                        readOnly={readOnly}
                        disabled={readOnly}
                      />
                    </td>
                  );
                })}
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AssortiTable; 